<template>
  <v-dialog
    v-model="isVisibleWindow"
    scrollable
    max-width="450"
    max-height="90%"
    min-width="90%"
  >
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{ $t("common.select") }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideWin">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <v-radio-group v-model="kindOfSupplier" row :disabled="!fetched">
          <v-radio
              :label="$t('common.legal_entity')"
              value="supplier"
              :disabled="!types.includes('suppliers')"
          ></v-radio>
          <v-radio
            :types="['suppliers','customers','users']"
            :disabled="!types.includes('users')"
            :label="$t('common.employee')"
            value="user"
          ></v-radio>
          <v-radio
              :disabled="!types.includes('customers')"
              :label="$t('common.customer')"
              value="customer"
          ></v-radio>
        </v-radio-group>
        <v-select
          v-if="kindOfSupplier === 'supplier'"
          :disabled="!fetched"
          :loading="!fetched"
          xs6
          :items="suppliers"
          item-text="name"
          v-model="selectedSupplier"
          return-object
          :label="$t('common.supplier')"
        >
        </v-select>
        <v-select
          v-if="kindOfSupplier === 'user'"
          :disabled="!fetched"
          :loading="!fetched"
          xs6
          :items="users"
          item-text="name"
          v-model="selectedSupplier"
          return-object
          :label="$t('common.supplier')"
        >
        </v-select>
        <v-select
          v-if="kindOfSupplier === 'customer'"
          :disabled="!fetched"
          :loading="!fetched"
          xs6
          :items="customers"
          item-text="full_name"
          v-model="selectedSupplier"
          return-object
          :label="$t('common.customer')"
        >
        </v-select>
      </v-card-text>
      <v-divider class=""></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" elevation="0" color="red" @click="hideWin">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
          class="white--text"
          elevation="0"
          color="success"
          @click="select"
          :disabled="!selectedSupplier"
        >
          {{ $t("common.select") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "SupplierSelectorWindow",
  components: {},
  props: {
    types: Array,
    supplier: null,
    isVisible: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapFields("suppliers", ["suppliers"]),
    ...mapFields("customers", ["customers"]),
    ...mapFields("users", ["users"]),
    ...mapFields("suppliers", { isFetchedSuppliers: "fetched" }),
    ...mapFields("customers", { isFetchedCustomers: "fetched" }),
    ...mapFields("users", { isFetchedUsers: "fetched" }),

    fetched() {
      return this.isFetchedUsers && this.isFetchedSuppliers && this.isFetchedCustomers;
    },
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  data: () => ({
    kindOfSupplier: "supplier", //организация(supplier) или сотрудник(user) или клиент (customer)
    selectedSupplier: null,
  }),
  methods: {
    select() {
      this.$emit("select", this.selectedSupplier);
      this.hideWin();
    },
    hideWin() {
      this.isVisibleWindow = false;
      this.selectedSupplier = null;
    },
  },
  watch: {
    kindOfSupplier() {
      this.selectedSupplier = null;
    },
    isVisible(to) {
      if (to) {
        this.$store.dispatch("users/get").then(()=>{
          this.$store.dispatch("suppliers/get").then(() => {
            this.$store.dispatch("customers/get").then(() => {
              if (this.supplier) {
                this.selectedSupplier = this.supplier;
                this.kindOfSupplier = this.supplier.type;
              }
            });
          });
        })

      }
    },
  },
};
</script>

<style scoped></style>
